import { httpClient } from '../http';
import { environmentBuilder } from '../../core/helpers/environmentBuilder';

class TranslationService {
  constructor({ url }) {
    this.url = url;
  }

  getTranslations(request) {
    const { applicationId, ...params } = request;
    return httpClient.get(this.url, {
      params,
      headers: { applicationId },
    });
  }
}
const { httpTranslationUrl } = environmentBuilder();

export const translationService = new TranslationService({ url: httpTranslationUrl });
